export default "__VITE_ASSET__DLobdcw6__"